import { Loader } from "./components/Loader";

export function LoadingScreen() {
  return (
    <div className="flex h-dvh w-full items-center justify-center bg-background">
      <Loader />
    </div>
  );
}
